import React, {useState} from "react";
import {Button, Col, Container, Form} from "react-bootstrap";
import Desplegable from "../desplegable";
import Footer from "../footer";
import $ from "jquery";
import * as utils from "../../utils.js";

const AgregarUsuario = (props) => {
    let [state, setState] = useState({
        drivingLicense: false,
        sendEmail: false,
    });


    const handleChange = (event) => {
        setState(prev => {
            return {
                ...prev,
                drivingLicense: !state.drivingLicense,
            }
        });
    }

    // Función para hacer el post a laicos
    const usuarioAdd = (event) => {
        // Comprueba si estamos añadiendo una monja o un laico
        let usuario = props.location.pathname === "/hermanas/add" ? "Monja" : "Laico";
        let myform = document.getElementById("MyForm");
        let form = new FormData(myform);

        let form2 = new FormData();

        for (let value of form.entries()) {
            if (value[1]) {
                form2.append(value[0], value[1]);
            }
        }

        event.preventDefault();
        let settings = {
            url: process.env.REACT_APP_API_URL + "/usuarios?type=" + usuario,
            method: "POST",
            timeout: 0,
            xhrFields: {
                withCredentials: true,
            },
            processData: false,
            mimeType: "multipart/form-data",
            contentType: false,
            data: form2,
        };
        if (
            utils.validPhoto(form.get("photo").size) &&
            utils.validPdf(form.get("passportDocument").size) // TODO Falta validar el pdf
        ) {
            $.ajax(settings)
                .done(function (response) {
                    props.setAlert("", "Se ha añadido el usuario correctamente", "success");
                    response = JSON.parse(response);

                    // De esta forma se redirige al perfil del laico o monja una vez se haya añadido.
                    if (props.history.location.pathname === "/laicos/add") {
                        props.history.push({
                            pathname: "/laicos/" + response.id,
                        });
                    } else if (props.history.location.pathname === "/hermanas/add") {
                        props.history.push({
                            pathname: "/hermanas/" + response.id,
                        });
                    }
                })
                .fail(props.ErrorHandling);
        } else {
            alert("El tamaño de la foto debe ser menor de 500KB y el de los pdfs de 2MB");
        }
    }

    // Para diferenciar entre laico y hermana
    let cv = (
        <Form.Group as={Col} lg="6">
            <Form.Label>Curriculum</Form.Label>
            <Form.Control type="file" name="cv"/>
        </Form.Group>
    );
    let gender = (
        <Form.Group as={Col}>
            <Form.Label>Sexo *</Form.Label>
            <Form.Check type="radio" label="Mujer" value="m" name="gender" defaultChecked/>
            <Form.Check type="radio" label="Hombre" name="gender" value="h"/>
        </Form.Group>
    );

    // Si es una hermana no mostramos ni genero ni cv
    if (props.history.location.pathname === "/hermanas/add") {
        cv = null;
        gender = null;
    }

    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();

    let documentDrivingLicense = state.drivingLicense ? (
        <Form.Group as={Col} xl="6">
            <Form.Label>Documento del Permiso de Conducir *</Form.Label>
            <Form.Control type="file" name="drivingLicense"/>
        </Form.Group>
    ) : null;

    // HTML con el formulario no tiene mucho que explicar excepto el componente Desplegable explicado en su fichero
    return (
        <React.Fragment>
            <Container className="my-5">
                <Form onSubmit={usuarioAdd} className="border rounded p-4" id="MyForm" autoComplete="off">
                    <Form.Row>
                        <small className="mb-3">
                            Los campos con un <b>*</b> deben de ser rellenados.
                        </small>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Nombre *</Form.Label>
                            <Form.Control required type="text" name="name" maxLength="45" autoComplete="nope"/>
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Primer Apellido *</Form.Label>
                            <Form.Control required type="text" name="firstSurname" maxLength="60"
                                          autoComplete="nope"/>
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Segundo Apellido</Form.Label>
                            <Form.Control type="text" maxLength="60" name="secondSurname" autoComplete="nope"/>
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Email *</Form.Label>
                            <Form.Control required type="email" name="email" maxLength="320" autoComplete="nope"/>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>País de Nacimiento</Form.Label>
                            <Form.Control type="text" name="birthCountry" maxLength="45" autoComplete="nope"/>
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Provincia de Nacimiento</Form.Label>
                            <Form.Control type="text" name="birthProvince" maxLength="45" autoComplete="nope"/>
                        </Form.Group>
                        <Form.Group as={Col} xl="4">
                            <Form.Label>Ciudad o localidad de Nacimiento</Form.Label>
                            <Form.Control type="text" name="birthAddress" maxLength="100" autoComplete="nope"/>
                        </Form.Group>
                        <Form.Group as={Col} xl="2">
                            <Form.Label>Fecha de Nacimiento </Form.Label>
                            <Form.Control type="date" name="birthdate" max={today} autoComplete="nope"/>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Nacionalidad </Form.Label>
                            <Form.Control type="text" name="nationality" maxLength="45" autoComplete="nope"/>
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Teléfono</Form.Label>
                            <Form.Control type="text" name="telephone" maxLength="35" autoComplete="nope"/>
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Tipo de Documento de Identidad</Form.Label>
                            <Form.Control as="select" name="documentType" alue="DNI">
                                <option value="DNI" defaultChecked>
                                    DNI
                                </option>
                                <option value="NIE">NIE</option>
                                <option value="Otro">Otro</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} xl="3">
                            <Form.Label>Número de Identidad</Form.Label>
                            <Form.Control type="text" name="documentId" maxLength="25" autoComplete="nope"/>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} xl="6">
                            <Form.Label>Fotografía <small>(máx. 500KB)</small></Form.Label>
                            <Form.Control type="file" name="photo"/>
                        </Form.Group>
                        {cv}
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xl="6">
                            <Form.Label>Carnet de Conducir <small>(máx. 500KB)</small></Form.Label>
                            <Form.Check type="radio" label="Sí" value="Si" checked={state.drivingLicense}
                                        onChange={handleChange}/>
                            <Form.Check type="radio" label="No" value="No" checked={!state.drivingLicense}
                                        onChange={handleChange}/>
                        </Form.Group>
                        {
                            // TODO poner name a este campo cuando este hecho en la api
                        }

                        {gender}
                        {documentDrivingLicense}
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xl="6">
                            <Form.Check type="checkbox" label="¿Enviar email de confirmación?" name="checkEmail"
                                        value="Si" defaultChecked/>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Desplegable
                            Toogle={"Datos Pasaporte"}
                            Text={
                                <Col>
                                    <Form.Row>
                                        <Form.Group as={Col} xl="6">
                                            <Form.Label>Número de pasaporte</Form.Label>
                                            <Form.Control type="text" name="passport" maxLength="35"
                                                          autoComplete="nope"/>
                                        </Form.Group>
                                        <Form.Group as={Col} xl="6">
                                            <Form.Label>Emitido por</Form.Label>
                                            <Form.Control type="text" name="passportIssued" maxLength="45"
                                                          autoComplete="nope"/>
                                        </Form.Group>

                                        <Form.Group as={Col} xl="12">
                                            <Form.Label>Lugar de emisión</Form.Label>
                                            <Form.Control type="text" name="passportPlace" maxLength="35"
                                                          autoComplete="nope"/>
                                        </Form.Group>

                                        <Form.Group as={Col} xl="6">
                                            <Form.Label>Fecha Emisión</Form.Label>
                                            <Form.Control type="date" name="issuedDate" max={today}
                                                          autoComplete="nope"/>
                                        </Form.Group>
                                        <Form.Group as={Col} xl="6">
                                            <Form.Label>Fecha Expiración</Form.Label>
                                            <Form.Control type="date" name="expiryDate" autoComplete="nope"/>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Group>
                                        <Form.Label>Archivo Pasaporte <small>(máx. 500KB)</small></Form.Label>
                                        <Form.Control type="file" name="passportDocument"/>
                                    </Form.Group>
                                </Col>
                            }
                        />
                    </Form.Row>
                    <Button variant="outline-primary" type="submit" className="my-3">
                        Añadir
                    </Button>
                </Form>
            </Container>
            <Footer/>
        </React.Fragment>
    );
}

export default AgregarUsuario;